import React, {useState } from 'react';
//import { useNavigate  , useSearchParams } from "react-router-dom";
//import {SvgOk} from '../Svg.js';
 
//import WindowsStyleDateTime from '../DataEx.js'; 

function FormPDV() {
  const [codigo, setCodigo] = useState("");
  const [nome,  setNome] = useState("");
  const [unitario,  setUnitario] = useState("");
  const [total,  setTotal] = useState("");

  const handleChange = (event) => {
    setCodigo(event.target.value);
    setNome(event.target.value);
    setUnitario(event.target.value);
    setTotal(event.target.value);


    console.log("Código digitado:", event.target.value);
  };

return (
<div class="areabox">
  <div class="pdvcontainer">
    <div class="pdvtop">Registro de Venda | 4</div>
    <div class="pdvleft">
  


<table>
  <tr>
    <td class="colpro1p">
    <p name="UmCodigo" class="ppro1p">{codigo}</p>
    <p name="UmNome" class="ppro1p">{nome}</p>
    <p name="UmUnitario" class="ppro1p">R$ {unitario} un</p>
    <p name="UmTotal" class="ppro1p"><b>R$ {total}</b></p>
    </td>
    
    <td width='20%' style={{ backgroundImage: `url('img/8.bmp')`, backgroundSize: 'cover', backgroundPosition: 'center', width:'250px', height:'100px'}}>
    &nbsp;
    </td>
  </tr>
  <tr>
					<td class="colpro1p">
						<form >
							<div class="form-group">
								<label for="Codigo"   class="form-controlp"> Codigo:</label><br/>
								<input name="Codigo"  class="form-controlc" type="text" size="10"  id="codigo"    value={codigo}      onChange={handleChange} /> <br />
								<label for="Tipo"     class="form-controlp">Quantidade:</label><br/>
								<input name="Tipo"    class="form-controlc" type="text"     size="5" value='' /><br />
								
							</div>
						</form>
					</td>
					<td class="colpro1p">
						&nbsp;
					</td>
          </tr>
          <tr>
          <td colspan="2">
          <h2 class="textototal1">Valor a Pagar:</h2>
          </td>
          </tr>
          <tr>
          <td colspan="2">
          <h2 class="textototal2"> 0,00</h2>
          </td>
          </tr>



<tr>
<td colspan="2" class="colpro2p">


<table class="colpro5p">
<tr ><td class="colpro3p">Trocas:</td><td class="colpro4p">0,00</td></tr>
<tr ><td class="colpro3p">Descontos:</td><td class="colpro4p">0,00</td></tr>
<tr ><td class="colpro3p">Acrescimos:</td><td class="colpro4p">0,00</td></tr>
<tr ><td class="colpro3p">Valor já pago:</td><td class="colpro4p">0,00</td></tr>
<tr ><td class="colpro3p"><b>Total:</b></td><td class="colpro4p"><b>0,00</b></td></tr>

</table>



</td>
</tr>
				

</table>




    </div>
    <div class="pdvright">
    <table class="pdvtableGrid">
      <thead>
        <tr>
          <th>N°</th>
          <th>Nome</th>
          <th>Qtd</th>
          <th>Uni</th>
          <th>Valor</th>
          <th>Total</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
      <tr>
            <td>codigo</td>
            <td class="thnome">nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>

          <tr>
            <td>codigo</td>
            <td>nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>

          <tr>
            <td>codigo</td>
            <td>nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>
          <tr>
            <td>codigo</td>
            <td>nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>
          <tr>
            <td>codigo</td>
            <td>nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>
          <tr>
            <td>codigo</td>
            <td>nome</td>
            <td>tipo</td>
            <td class="thcentro">ps</td>
            <td class="thdireito">estoqueAtual</td>
            <td class="thdireito">valor</td>
            <td class="thcentro">"X"</td>
            <td>
              &nbsp;
            </td>
          </tr>

      </tbody>
    </table>
    </div>  


    <div class="pdvbottom">
      &nbsp;&nbsp;
      <button class="pdvbotaocinsa"><b>&lt;F2&gt;</b> <br/>Peso ou <br/>Quantidade</button>
      <button class="pdvbotaocinsa"><b>&lt;F3&gt;</b> <br/>Juntar <br/>Fichas</button>
      <button class="pdvbotaocinsa"><b>&lt;Inser&gt;</b> <br/>Consultar <br/>Produtos</button>
      <button class="pdvbotaocinsa"><b>&lt;F5&gt;</b> <br/>Identificar<br/>cliente</button>
      <button class="pdvbotaocinsa"><b>&lt;F6&gt;</b> <br/>Imprimir <br/><br/></button>
      <button class="pdvbotaocinsa"><b>&lt;F7&gt;</b> <br/>Alterar <br/>Item</button>
      <button class="pdvbotaocinsa"><b>&lt;Enter&gt;</b> <br/>Confirma<br/>Venda</button>
    </div>


  </div>  
  
</div>  
  );
}

export default FormPDV;